import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class CasinoConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.casino, meta);
    }
    getCategories(params) {
        return this.applyQuery(QueryBuilder.getCategories(params));
    }
    getFreespins(params) {
        return this.applyQuery(QueryBuilder.getFreespins(params));
    }
    getGames(params) {
        return this.applyQuery(QueryBuilder.getGames(params));
    }
    getLaunchParams(params) {
        return this.applyQuery(QueryBuilder.getLaunchParams(params));
    }
}
//# sourceMappingURL=CasinoConnection.js.map